export const referential = {
  error: {
    "condition-ratings": "Could not load condition ratings referential!",
  },
};
